import React from 'react';
import { useTranslation } from 'react-i18next';
import { LocationDescriptorObject } from 'history';
import { ITourDetail, TourVisibility } from '@lialo/core/lib/models';
import { IRatingVM } from '@lialo/core/lib/pages/tourDetail/models';

import { Page } from '@lialo/pwa-ui/lib/PageComponents/Page';
import { AppBar } from '@lialo/pwa-ui/lib/PageComponents/AppBar';
import RouterBackButton from '../../../common/Page/AppBarButtons/RouterBackButton';
import { ShareTourButton } from '../../../common/Button/ShareTourButton';
import ShareIconButton from '../../../common/Button/ShareIconButton';
import TourDetailContent from './TourDetailContent';
import BottomActionBar from './BottomActionBar';
import { useLocation } from 'react-router-dom';
import { useServiceProvider } from '../../../common/Providers';
import { TourDetailHelmet } from './TourDetailHelmet';

interface IProps {
  tourCode: string;
  tour: ITourDetail;
  tourRatings: IRatingVM[];
  returnToLocation: LocationDescriptorObject | null;
  numberOfComments: number;
  requiresPurchase: boolean;
}

const TourDetail = ({ tourCode, tour, tourRatings, returnToLocation, numberOfComments, requiresPurchase }: IProps) => {
  const { t } = useTranslation();
  const { state } = useLocation<{ canGoBack?: boolean }>();
  const { navigationService } = useServiceProvider();

  const homeRoute = () => navigationService.generateFindTourLink(undefined, tour.startLocation, tourCode, 10);

  return (
    <Page style={{ position: 'relative' }}>
      <TourDetailHelmet tour={tour} />
      <AppBar
        leftElement={<RouterBackButton parentUrl={returnToLocation || homeRoute()} forceReplace={!state?.canGoBack} />}
        title={
          tour.visibility === TourVisibility.PUBLIC && !tour.settings?.playAtHome ? t('tour_detail.title') : undefined
        }
        titleComponent={'div'}
        rightElement={
          <ShareTourButton
            tour={{
              tourCode: tour.shortLink,
              authorId: tour.user.id,
              city: tour.startLocation?.city,
              price: tour.price,
            }}
            button={<ShareIconButton />}
          />
        }
      />
      <TourDetailContent
        tour={tour}
        tourCode={tourCode}
        tourRatings={tourRatings}
        numberOfComments={numberOfComments}
      />

      <BottomActionBar
        tourCode={tourCode}
        hasInsight={tour.visibility === TourVisibility.PUBLIC}
        couponAvailable={!!tour.price}
        requiresPurchase={requiresPurchase}
      />
    </Page>
  );
};

export default TourDetail;
